import { openBlock as e, createElementBlock as a, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M14.113 1.318a.75.75 0 0 1 .569.57c.115.518-.064 1.07-.256 1.495-.209.46-.512.942-.838 1.389-.528.722-1.18 1.439-1.717 1.89v6.702a.75.75 0 0 1-.22.53l-.706.707a.75.75 0 0 1-1.258-.348L8.594 9.881l-.965.965v2.518a.75.75 0 0 1-.22.53l-.707.707a.75.75 0 0 1-1.242-.293L4.924 12.7H4.05a.75.75 0 0 1-.75-.75v-.874l-1.608-.536a.75.75 0 0 1-.293-1.242l.707-.707a.75.75 0 0 1 .53-.22h2.518l.965-.965-4.372-1.093A.75.75 0 0 1 1.4 5.055l.707-.707a.75.75 0 0 1 .53-.22H9.34c.45-.535 1.167-1.188 1.89-1.716a8.08 8.08 0 0 1 1.389-.838c.425-.192.976-.371 1.495-.256Zm-2 2.306c-.813.594-1.53 1.302-1.787 1.678a.75.75 0 0 1-.619.327H5.193l2.575.643a.75.75 0 0 1 .348 1.258L5.995 9.652a.75.75 0 0 1-.53.22H4.399a.75.75 0 0 1 .401.664v.664h.665a.75.75 0 0 1 .664.401v-1.065a.75.75 0 0 1 .22-.53l2.12-2.122a.75.75 0 0 1 1.259.348l.643 2.575V6.293a.75.75 0 0 1 .327-.62c.377-.256 1.084-.973 1.678-1.786.192-.262.36-.52.497-.76-.24.137-.498.306-.76.497Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  o
];
function n(r, d) {
  return e(), a("svg", t, [...c]);
}
const v = { render: n };
export {
  v as default,
  n as render
};
